__turbopack_context__.v({
  "bulletItem": "PromotionsHomePage-module__rrqi-q__bulletItem",
  "bulletList": "PromotionsHomePage-module__rrqi-q__bulletList",
  "description": "PromotionsHomePage-module__rrqi-q__description",
  "disclaimer": "PromotionsHomePage-module__rrqi-q__disclaimer",
  "imageWrapper": "PromotionsHomePage-module__rrqi-q__imageWrapper",
  "primaryCta": "PromotionsHomePage-module__rrqi-q__primaryCta",
  "promotionWrapper": "PromotionsHomePage-module__rrqi-q__promotionWrapper",
  "secondaryCta": "PromotionsHomePage-module__rrqi-q__secondaryCta",
  "secondaryPromotion": "PromotionsHomePage-module__rrqi-q__secondaryPromotion",
  "secondaryPromotionsContainer": "PromotionsHomePage-module__rrqi-q__secondaryPromotionsContainer",
  "secondaryPromotionsWrapper": "PromotionsHomePage-module__rrqi-q__secondaryPromotionsWrapper",
  "tertiaryPromotion": "PromotionsHomePage-module__rrqi-q__tertiaryPromotion",
  "textWrapper": "PromotionsHomePage-module__rrqi-q__textWrapper",
  "title": "PromotionsHomePage-module__rrqi-q__title",
  "truncateText": "PromotionsHomePage-module__rrqi-q__truncateText",
  "wrapper": "PromotionsHomePage-module__rrqi-q__wrapper",
});
